import { User } from 'firebase/auth';

/**
 * Initiates Kroger OAuth connection flow
 */
export const initiateKrogerConnection = async (user: User): Promise<void> => {
  if (!user) {
    throw new Error('You must be signed in to connect Kroger.');
  }

  try {
    const token = await user.getIdToken();
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/kroger/url?token=${encodeURIComponent(token)}`);
    
    if (!response.ok) {
      throw new Error('Failed to get authorization URL');
    }

    const { authUrl } = await response.json();
    
    // Redirect to Kroger OAuth
    window.location.href = authUrl;
  } catch (error) {
    console.error('Error initiating Kroger OAuth:', error);
    throw new Error('Failed to connect to Kroger. Please try again.');
  }
};